<template>
  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/admin/addOrganization'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h2>افزودن انجمن دانشجویی جدید</h2>
      <hr />
      <b-row>
        <b-col cols="12" sm="12" md="12" lg="12" class="">
          <b-form-group
            label="نام انجمن دانشجویی"
            :class="newOrganization.name ? 'done' : 'required'"
          >
            <b-form-input
              trim
              v-model="newOrganization.name"
              type="text"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="نام دبیر انجمن دانشجویی">
            <b-form-input
              trim
              v-model="newOrganization.headName"
              :no-wheel="true"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group
        label="نام دانشکاه"
        :class="newOrganization.universityId ? 'done' : 'required'"
      >
        <v-autocomplete
          v-model="newOrganization.universityId"
          :items="universities"
          item-value="id"
          item-text="text"
          dense
          outlined
          class="dropdown-style"
          hide-details
        ></v-autocomplete>
      </b-form-group>

      <b-button
        :disabled="
          isBusy || !newOrganization.name || !newOrganization.universityId
        "
        variant="success"
        @click="addOrganization()"
        >افزودن</b-button
      >
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import router from "../../router";
import utilities from "../../mixins/utilities";
import Select2 from "v-select2-component";

export default {
  components: {
    Select2,
  },
  mixins: [utilities],

  data() {
    return {
      newOrganization: {},
      isBusy: false,
      universities: [],
    };
  },

  methods: {
    addOrganization() {
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/organization/new",
          {
            name: this.newOrganization.name,
            headName: this.newOrganization.headName,
            universityId: this.newOrganization.universityId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast("انجمن دانشجویی با موفقیت ثبت شد.", "success");
          this.$router.push("/admin/organizations");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
          this.isBusy = false;
        });
    },

    getUniversities() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },

  mounted() {
    this.getUniversities();
  },
};
</script>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style lang="scss">
.color {
  background-color: #0c4961;
  color: white;
}
.image-box {
  height: 100px;
  width: 90%;
  margin: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  img {
    width: 100%;
    height: 100%;
  }
}
.profile-modalCard {
  border-radius: 10px !important;
  overflow: hidden !important;
  .image-box {
    height: 60vh;
    width: 75vh;
    max-width: 100%;
    max-height: 500px;
    min-width: 300px;
    margin: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(61, 60, 60, 0.781);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(46, 45, 45, 0.945);
    border-radius: 6px;
  }

  .cancel-btn {
    background-color: #6399e2 !important;
    color: #fff !important;
    box-shadow: none !important;
    width: 110px !important;
  }
  .cancel-btn {
    background-color: rgb(182, 39, 39) !important;
    color: #fff;
    box-shadow: none !important;
    width: 110px !important;
  }
  .change-btn {
    background-color: #6399e2 !important;
    color: #fff !important;
    box-shadow: none !important;
    width: 110px !important;
  }
}
.modal-card {
  .upload-box {
    padding: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='9' ry='9' stroke='rgb(6, 141, 157)' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='5' stroke-linecap='butt'/%3e%3c/svg%3e");
  }
  .file-icon {
    path {
      stroke: #068d9d;
    }
  }
}
.uploadPercentage {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 70;
  padding: 10px;
  span {
    color: #93329e !important;
    margin: auto;
    font-size: 0.9rem;
  }
}
.v-text-field .v-input__slot,
.v-text-field fieldset {
  border-radius: 6px !important;
  border-color: #93329e !important;
}
.v-input__slot {
  min-height: 48px !important;
  margin-bottom: 25px;
  input {
    color: #656a81 !important;
  }
  .v-text-field__suffix {
    color: #656a81 !important;
  }
}

label.v-label.v-label--active.theme--light {
  font-size: 0.9rem !important;
  color: #93329e !important;
  background-color: #fff;
  padding: 1px 10px;
  margin-bottom: 0 !important;
  height: 25px;
  transform: translateY(-31px);
}
.v-input__icon--prepend button {
  color: #93329e !important;
}

/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
.required {
  color: red;
}

.done {
  color: green;
}
</style>
